import { isProd } from "@/constants/env";

export const API_URL = isProd
  ? "https://services.api.seeri.co"
  : "https://services.dev.api.seeri.co";
